import { render, staticRenderFns } from "./AllegatiPrestazioni.vue?vue&type=template&id=2f24b804&"
import script from "./AllegatiPrestazioni.vue?vue&type=script&lang=js&"
export * from "./AllegatiPrestazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports